import { buildQueryContext, QueryFormData } from '@superset-ui/core';

// basic

// export default function buildQuery(formData: QueryFormData) {
//   const { columns = [], category = [] } = formData;
//   const groupbySet = new Set([
//     ...ensureIsArray<QueryFormColumn>(columns),
//     ...ensureIsArray<QueryFormColumn>(category),
//   ]);
//   return buildQueryContext(formData, baseQueryObject => {
//     const { series_limit_metric, metrics, order_desc } = baseQueryObject;
//     let orderBy: QueryFormOrderBy[] | undefined;
//     if (series_limit_metric) {
//       orderBy = [[series_limit_metric, !order_desc]];
//     } else if (Array.isArray(metrics) && metrics[0]) {
//       orderBy = [[metrics[0], !order_desc]];
//     }
//     return [
//       {
//         ...baseQueryObject,
//         orderby: orderBy,
//         columns: [...groupbySet],
//       },
//     ];
//   });
// }

export default function buildQuery(formData: QueryFormData) {  
  return buildQueryContext(formData, baseQueryObject => [
    {
      ...baseQueryObject,
    },
  ]);
}